import type { ReactNode } from "react";

interface CalculatorActivePanelProps {
  children: ReactNode;
}

/** Responsive wrapper for an open calculator — prevents 375px overflow from wide grids/tables. */
export function CalculatorActivePanel({ children }: Readonly<CalculatorActivePanelProps>) {
  return <div className="min-w-0 w-full overflow-x-hidden">{children}</div>;
}
